import {
  LogoutOutlined,
  SettingOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import type { MenuProps } from 'antd';
import { Spin } from 'antd';
import { createStyles } from 'antd-style';
import React, { useState } from 'react';
import { flushSync } from 'react-dom';
import { logout } from '@/services/common';
import HeaderDropdown from '../HeaderDropdown';
import ResetPassword from './components/ResetPassword';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { currentUser } = initialState || {};
  return <span className="anticon">{currentUser?.name}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({
  menu,
  children,
}) => {
  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel('@@initialState');
  const [modalVisible, setModalVisible] = useState(false);
  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      flushSync(() => {
        setInitialState((s) => ({ ...s, currentUser: undefined }));
      });
      logout();
      return;
    }
    if (key === "changePassword") {
        setModalVisible(true);
        return;
    }
    history.push(`/account/${key}`);
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { currentUser } = initialState;

  if (!currentUser || !currentUser.name) {
    return loading;
  }

  const menuItems = [
      ...(menu
          ? [
                {
                    key: "center",
                    icon: <UserOutlined />,
                    label: "个人中心",
                },
                {
                    key: "settings",
                    icon: <SettingOutlined />,
                    label: "个人设置",
                },
                {
                    type: "divider" as const,
                },
            ]
          : []),
      {
          key: "changePassword",  
          icon: <SettingOutlined />, 
          label: "修改密码",
      },
      {
          key: "logout",
          icon: <LogoutOutlined />,
          label: "退出登录",
      },
  ];

  return (
      <>
          <HeaderDropdown
              menu={{
                  selectedKeys: [],
                  onClick: onMenuClick,
                  items: menuItems,
              }}
          >
              {children}
          </HeaderDropdown>
          <ResetPassword
              visible={modalVisible}
              onClose={() => setModalVisible(false)}
          />
      </>
  );
};
